const BulmaTable = r => require.ensure([], () => r(require('./BulmaTable.vue')), 'shared')

export default BulmaTable
